import * as React from "react"

import LoginWithApple from "../login-with-apple"
import LoginWithFacebook from "../login-with-facebook"
import LoginWithGoogle from "../login-with-google"
import { Stack } from "@mui/material"
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { authSocialLogin } from "@/redux/auth/services"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { toaster } from "@/components/reusables/toaster"
import { useTranslation } from "react-i18next"

interface ILoginWithSocialsProps {}

const LoginWithSocials: React.FunctionComponent<ILoginWithSocialsProps> = (
  props
) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [submitting, setSubmitting] = React.useState({});

  const { t } = useTranslation(["inputValidations", "common"])

  // Configure Firebase.
  const config = {
    apiKey: "AIzaSyCTut2dGJ8RUAr9dHZAtuapIxN187ClXQM",
    authDomain: "arenpro-bcb83.firebaseapp.com",
  };
  firebase.initializeApp(config);

  // Configure FirebaseUI.
  const uiConfig: any = {
    signInFlow: 'popup',
    callbacks: {
      signInSuccess: (user, response) => {
        console.log(user, response);
        dispatch(
          authSocialLogin(
            {idToken: user._delegate.accessToken},
            setSubmitting,
            ({ data }) => {
              const { user } = data
              setTimeout(() => {
                setSubmitting(false)
                toaster.success(t("common:you_logged_in_succesfully"))
                if (user.role === "super-admin") navigate("/admin-dashboard")
                else navigate("/dashboard/projects")
              }, 100)
            },
            (e) => {
              setSubmitting(false)
              toaster.error(e)
            }
          )
        )
      }
    },
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    ],
  };

  return (
    <Stack direction="row" justifyContent={"space-between"} alignItems="center">
      
      {/* <LoginWithGoogle /> */}
      <Stack direction="row">
        {uiConfig && (
          <StyledFirebaseAuth
            uiConfig={uiConfig}
            firebaseAuth={firebase.auth()}
          />
        )}
        {/* <LoginWithApple />
        <LoginWithFacebook /> */}
      </Stack>
    </Stack>
  )
}

export default LoginWithSocials
